import { useState } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function Login() {
  const { login, error } = useAuth();
  const navigate = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const ok = await login(email, password);
    setBusy(false);
    if (ok) navigate(loc.state?.from || "/feed");
  };

  return (
    <div className="min-h-[80vh] grid lg:grid-cols-2" data-testid="login-page">
      <div className="hidden lg:block relative">
        <img src="https://images.unsplash.com/photo-1543372654-b45dd90eeee5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHw0fHx1cyUyMGNhcGl0b2wlMjBidWlsZGluZyUyMHdhc2hpbmd0b24lMjBkY3xlbnwwfHx8fDE3ODI2NjMyODF8MA&ixlib=rb-4.1.0&q=85" className="absolute inset-0 w-full h-full object-cover" alt="" />
        <div className="absolute inset-0 bg-[#0A192F]/70" />
        <div className="relative h-full flex flex-col justify-end p-12 text-[#FDFBF7]">
          <div className="label-eyebrow text-[#C5A059]">Member sign-in</div>
          <h2 className="mt-3 font-display text-5xl leading-tight">Welcome back to the Association.</h2>
        </div>
      </div>
      <div className="flex items-center justify-center p-8 lg:p-16">
        <form onSubmit={submit} className="w-full max-w-md space-y-6">
          <div>
            <div className="label-eyebrow">Sign in</div>
            <h1 className="mt-2 font-display text-4xl text-[#0A192F]">Members entrance</h1>
            <p className="mt-2 text-sm text-slate-600">Use your verified PMF email to access the community feed, groups, and messages.</p>
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" value={email} onChange={e => setEmail(e.target.value)} required data-testid="login-email-input" placeholder="you@agency.gov" className="h-11" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="password">Password</Label>
            <Input id="password" type="password" value={password} onChange={e => setPassword(e.target.value)} required data-testid="login-password-input" className="h-11" />
          </div>
          {error && <div className="text-sm text-[#9B111E]" data-testid="login-error">{error}</div>}
          <Button type="submit" disabled={busy} data-testid="login-submit-button" className="w-full bg-[#002855] hover:bg-[#0A192F] text-white h-11 rounded-md">{busy ? "Signing in…" : "Sign in"}</Button>
          <div className="text-sm text-slate-600">Not a member yet? <Link to="/register" className="text-[#002855] font-medium hover:text-[#C5A059]">Create your account →</Link></div>
          <div className="text-xs text-slate-400 border-t pt-4">Demo: <span className="font-mono">member@pmfa.org</span> / <span className="font-mono">Member123!</span></div>
        </form>
      </div>
    </div>
  );
}
